import axios from "axios";
import { GET_ALL_FORM_CONFIGURATION_BY_FORMID } from "./types";
const keys = require("../config/keys");

export const getAllAdmissionFormConfigurationByFormId = FormGroupID => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAllAdmissionFormConfigurationByFormId?FormGroupID=" +
      FormGroupID
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_FORM_CONFIGURATION_BY_FORMID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllAdmissionFormConfigurationByFormId.js